import { faCopy, faEdit, faEye, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import Table from '../../Common/table';
import swal from 'sweetalert';
import axios from 'axios';
import dateTime from '../../utill/dateTime';
import api from '../../config.json'
import Excelimport from '../../utill/Excelimport';
import Loading from '../../utill/LoadingComponent';
import PaginationComponent from '../../Common/PaginationComponent';
import { cloneDeep } from 'lodash';

const CustomInspectionList = ({ history, RightName, getRightsForAccess, Heading }) => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'ListName', order: 'asc' })

    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(5);
    const [PageSize, setPageSize] = useState(10);

    const reportType = [
        { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    useEffect(() => {
        Heading('Inspection Master')
        handleGetData()
    }, [CurrentPage, PageSize])

    // const handleGetData = () => {
    //     axios.get(api.api + 'customInspection')
    //         .then((result) => {
    //             // consol(result.data)
    //             setLoader(false)
    //             setList(result.data);
    //         })
    //         .catch((err) => {
    //             swal(`${err}`)
    //             setLoader(false)
    //         })
    // }
    const handleGetData = async (search, Query) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)

        if (search) {
            axios.put(api.api + 'customInspection', { query: 'Search', Item: Query, PageSize: PageSize, Page: CurrentPage })
                .then((result) => {
                    setLoader(false)
                    setTotalPage(Math.ceil(result.data.totalDocument / PageSize));
                    setList(result.data.data);
                    //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
                })

                .catch((err) => {
                    setLoader(false)
                    console.log(err);
                })
        } else {
            axios.put(api.api + 'customInspection', { query: '', Item: '', PageSize: PageSize, Page: CurrentPage })
                .then((result) => {
                    setLoader(false)
                    setTotalPage(result.data.totalDocument);
                    setList(result.data.data);
                    //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
                })

                .catch((err) => {
                    setLoader(false)
                    console.log(err);
                })
        }

    }
    const onDelete = (data) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this",
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then(willDelete => {
            if (willDelete) {

                axios
                    .delete(api.api + "customInspection/" + data._id, { data: data })
                    .then(result => {
                        // consol(result.data)
                        if (result.data.ok === 1 && result.data.deletedCount === 1) {
                            let filterData = list.filter(
                                obj => obj._id !== data._id
                            );
                            setList(filterData)
                            swal("SUCCESS", "Inspection Delete Successfully")
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            swal(`${err.response.data.message}`);

                        } else {
                            swal(`${err}`);

                        }
                    });
            } else {

                // swal("Your imaginary file is safe!");
            }
        });
    }


    const columns = [
        { path: 'InspectionType', label: 'Inspection Type' },
        { path: 'ApprovalReq', label: 'Appoval Required' },
        { path: 'DateTime', label: 'Date / Time' },
        { path: 'ContinousDataEntry ', label: 'Continous Data Entry ', content: (obj) => <React.Fragment><label>{obj.ContinousDataEntry == 'enable' ? "Yes" : 'No'}</label><br /></React.Fragment> },
        { path: 'SampleSerial', label: 'Sample Serial' },
        { path: 'SampleSerialUnique', label: 'Sample Serial Unique' },
        { path: 'InstrumentReq', label: 'Instrument Master' },
        { path: 'NGResultWarning', label: 'Warning For NG Result' },
        { path: 'NGResultAlert', label: 'NG Result Alert' },
        { path: 'EnableSave', label: 'Enable Save' },
        { path: 'ImageCapture', label: 'Image Capture' },
        { path: 'DefaultSelection', label: 'Default Selection' },
        { key: 'createdAt', label: 'Created Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.createdAt)}</label><br /></React.Fragment> },
        { key: 'updatedAt', label: 'Last Updated Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label><br /></React.Fragment> },
        { key: 'edit', content: user => <button onClick={() => history.push("/setting/custom_inspection/form", { action: "edit", data: user })} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faEdit} /></button> },
        {
            key: 'copy', content: user => <button

                onClick={() =>{
                    const obj=cloneDeep(user);
                    delete obj._id;
                    obj.InspectionType = "(Copy) "+obj.InspectionType;
                    history.push("/setting/custom_inspection/form", { action: "copy", data: obj })
                }}
                className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faCopy} /></button>
        },
        { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }
    ]

    return (<>
        {/* <div className='text-center'>
            <p>Inspection Master List</p>
        </div> */}

        {getRightsForAccess('StaticDataRights', RightName, "write") && <a onClick={() => history.push('/setting/custom_inspection/form', { action: "add", data: {} })} style={{ cursor: 'pointer' }} className='float-right common-anchor'

        >
            <FontAwesomeIcon size='1x' icon={faPlus} /> Add </a>}
        {/* <a
          style={{ cursor: "pointer", color: 'white' }}
          className="float-left btn btn-sm btn-primary "
          //onClick={this.handleUploadGuagesDoc}
        >
          {" "}

          <FontAwesomeIcon size="1x" icon={faFileImport} /> Import Excel
        </a> */}
        {/* {getRightsForAccess('StaticDataRights', RightName, "write") &&  <Excelimport />} */}
        {list.length < 0 ? "Data Not Available" : <Table sortColumn={sortColumn} columns={columns} data={list} searchquery={true} handelSearch={handleGetData} />}
        {list.length > 0 && <div className="float-end m-3">
             <PaginationComponent
                     current={CurrentPage}
                     pageSize={PageSize}
                     totalItems={TotalPage * PageSize}  // or just use total count
                     onPageChange={(page, size) => {
                       if (size !== PageSize) setCurrentPage(1);
                       else setCurrentPage(page);
                       setPageSize(size);
                     }}
                   />
        </div>}
    </>);
}

export default CustomInspectionList;